const Vue = require('vue')

Vue.component('condominium-search', require('components/building/Select.vue'))



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/condominium-search.js